// Recording indicator — the app's signature element: a small live waveform
// plus a pulsing red dot and elapsed-time counter, used on both recording
// screens (Section 10: TEXT_RECORDING, IMAGE_RECORDING).

import { useEffect, useState } from 'react';

function formatElapsed(ms) {
  const totalSeconds = Math.floor(ms / 1000);
  const m = Math.floor(totalSeconds / 60);
  const s = totalSeconds % 60;
  return `${m}:${String(s).padStart(2, '0')}`;
}

export default function RecordingIndicator({ startedAt }) {
  const [now, setNow] = useState(Date.now());

  useEffect(() => {
    const id = setInterval(() => setNow(Date.now()), 500);
    return () => clearInterval(id);
  }, []);

  const elapsed = startedAt ? now - new Date(startedAt).getTime() : 0;

  return (
    <div className="flex items-center gap-3 rounded-full bg-stop/10 border border-stop/30 px-4 py-2 w-fit mx-auto">
      <span className="relative flex h-3 w-3">
        <span className="absolute inline-flex h-full w-full rounded-full bg-stop animate-pulseDot" />
      </span>
      <div className="flex items-end gap-[3px] h-4" aria-hidden="true">
        {[0, 1, 2, 3, 4].map((i) => (
          <span
            key={i}
            className="w-[3px] bg-stop rounded-full animate-waveform"
            style={{ height: '100%', animationDelay: `${i * 0.12}s` }}
          />
        ))}
      </div>
      <span className="text-stop font-semibold tabular-nums text-sm">{formatElapsed(elapsed)}</span>
    </div>
  );
}
